
var React = require('react');

module.exports = function() {
  return React.createElement(
	"svg",
	{ viewBox: "0 0 64 64" },
	React.createElement(
		"g",
		{ fill: "#3e4347" },
		React.createElement("circle", { cx: "32", cy: "32", r: "30" }),
		React.createElement("path", { d: "m6.3 18l-2.7-2.7c-2.1-2.1-2.1-5.5 0-7.5l4.2-4.2c2.1-2.1 5.5-2.1 7.5 0l2.7 2.7-3.1 3.1-2.7-2.7c-.3-.3-.9-.3-1.3 0l-4.2 4.2c-.3.3-.3.9 0 1.3l2.7 2.7-3.1 3.1" }),
		React.createElement("path", { d: "m57.7 46l2.7 2.7c2.1 2.1 2.1 5.5 0 7.5l-4.2 4.2c-2.1 2.1-5.5 2.1-7.5 0l-2.7-2.7 3.1-3.1 2.7 2.7c.3.3.9.3 1.3 0l4.2-4.2c.3-.3.3-.9 0-1.3l-2.7-2.7 3.1-3.1" })
	),
	React.createElement("circle", { cx: "32", cy: "32", fill: "#f2b200", r: "23.4" }),
	React.createElement("path", { d: "m39.6 11.4c-5-2.6-12.9 2.4-12 6.6.9 4.2 11.2 7.2 14 13.1 2.8 5.9 4.1 7.8 9.1 3.8 4.9-4.1 7.2-13.8-11.1-23.5", fill: "#b47d56" }),
	React.createElement(
		"g",
		{ fill: "#89664c" },
		React.createElement("path", { d: "m38.8 13.8c3.4 0-2.1 1.9-5.3 4.7-1.6 1.4-.9-4.7 5.3-4.7" }),
		React.createElement("path", { d: "m46.1 18.7c3.4 0-2.1 1.9-5.4 4.7-1.5 1.3-.8-4.7 5.4-4.7" }),
		React.createElement("path", { d: "m50.6 26.2c3.4 0-2.1 1.9-5.4 4.7-1.5 1.3-.7-4.7 5.4-4.7" })
	),
	React.createElement("path", { d: "m10.7 38c-1.9-4.8 4.4-10.7 8.5-9.2 4.2 1.5 5.7 10.9 11.2 14.4 5.5 3.4 7.3 4.9 2.5 8.5-4.9 3.6-15.1 3.8-22.2-13.7", fill: "#b47d56" }),
	React.createElement(
		"g",
		{ fill: "#89664c" },
		React.createElement("path", { d: "m13.4 39.3c-.5 2.9 2.2-1.5 5.6-3.8 1.6-1.1-4.7-1.5-5.6 3.8" }),
		React.createElement("path", { d: "m16.8 45.4c-.5 2.9 2.2-1.5 5.6-3.8 1.6-1.1-4.7-1.5-5.6 3.8" }),
		React.createElement("path", { d: "m22.8 49.9c-.5 2.9 2.2-1.5 5.6-3.8 1.6-1.1-4.6-1.6-5.6 3.8" })
	),
	React.createElement(
		"g",
		{ fill: "#699635" },
		React.createElement("path", { d: "m25.6 13c-2.2-2.1-2.2-2.1-8.6 4.6-3.5 3.7-5.3 7.6-4.1 8.7 2.2 2.1 2.2 2.1 8.5-4.6 3.6-3.6 5.4-7.5 4.2-8.7" }),
		React.createElement("path", { d: "m51.5 40.2c-1.8-2.4-1.8-2.4-9.1 2.8-4.1 2.9-6.5 6.3-5.6 7.6 1.8 2.4 1.8 2.4 9.1-2.8 4.1-2.9 6.6-6.3 5.6-7.6" }),
		React.createElement("path", { d: "m38.6 33.2c1.3-3 1.3-3-7.5-7.1-4.9-2.3-9.4-2.8-10.1-1.2-1.3 3-1.3 3 7.5 7.1 4.8 2.3 9.3 2.8 10.1 1.2" })
	),
	React.createElement("path", { d: "m43.5 37.8c.2-2.2-1.6-1.1-4.9-1.2-3.3-.2-2.4 2.4-2.2 4.5.1 2.1 1.4.4 6.2.5 1.8.1.6-1.6.9-3.8", fill: "#ed4c5c" }),
	React.createElement("path", { d: "m29.9 34.1c-2.5-.9-1.7.8-3 3.2-1.3 2.4 2.1 2.5 4.6 3.1 2.5.6.9-.9 2.6-4.4.7-1.3-1.7-1-4.2-1.9", fill: "#ffce31" }),
	React.createElement("path", { d: "m24.5 18.9c-2.5-.9-1.7.8-3 3.2-1.3 2.4 2.1 2.5 4.6 3.1 2.5.6.9-.9 2.6-4.4.7-1.3-1.7-1-4.2-1.9", fill: "#ed4c5c" }),
	React.createElement("path", { d: "m14 26.2c-2.5-.9-1.7.8-3 3.2-1.3 2.4 2.1 2.5 4.6 3.1 2.5.6.9-.9 2.6-4.4.7-1.4-1.7-1.1-4.2-1.9", fill: "#ffce31" })
);
};



//////////////////
// WEBPACK FOOTER
// ./~/react-svg-emojione/dist/shallow_pan_of_food.js
// module id = 719
// module chunks = 0